import React from "react";
import "./style.css";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Loader2 from "../../components/Loader2/Loader2";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { handleAuth0Error, createAuth0Url, safeRedirect } from "../../utils/auth0ErrorHandler";

const LoginScreen = () => {
  const { isLoading, isAuthenticated, error, user, loginWithRedirect } =
    useAuth0();

  if (error) {
    return <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}
    >
      <p>Oops... {error.message}</p>
    </div>;
  }

  const dispatch = useDispatch();

  if (isAuthenticated) {
    dispatch({ type: "STORE_AUTH0_USER_INFOS", payload: user });
    localStorage.setItem("userAuth0Connected", JSON.stringify(user));
  }

  // Fonction pour gérer le login de manière plus robuste
  const handleLogin = async () => {
    try {
      await loginWithRedirect({
        redirectUri: window.location.origin,
        appState: {
          returnTo: window.location.pathname
        }
      });
    } catch (err) {
      console.error('Erreur lors du login:', err);
      
      // Gérer l'erreur de manière intelligente
      const errorInfo = handleAuth0Error(err);
      
      if (errorInfo.action === 'redirect_to_login') {
        // Créer une URL Auth0 manuelle comme fallback
        const auth0Url = createAuth0Url(
          process.env.REACT_APP_AUTH0_DOMAIN,
          process.env.REACT_APP_AUTH0_CLIENT_ID,
          window.location.origin
        );
        safeRedirect(auth0Url);
      } else {
        // Afficher l'erreur à l'utilisateur
        console.error('Erreur non récupérable:', errorInfo.message);
      }
    }
  };

  return (
    <div className='login_screen'>
      <div className='col_1'></div>
      <div className='col_2'>
        <img src='/sparkly_logo_jaune.svg' className='logo' width="50%" alt='Sparkly' />
        <form action=''>
          {error && <div>Oops... {error.message}</div>}

          {isLoading ? (
            <div style={{ marginBottom: 20, marginTop: 20 }}>
              {isLoading && <Loader2 />}
            </div>
          ) : isAuthenticated ? (
            <Navigate to='/campagne/ajouter-compte' replace={true} />
          ) : (
            <button 
              onClick={handleLogin} 
              className='login_btn'
              type="button"
            >
              <FormattedMessage defaultMessage='Log in' id='screen_login' />
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
